module.exports = __webpack_public_path__ + "static/media/grooveyard.8ef4ce44.png";